import React, { useEffect, useState } from "react";
import { UTILS } from "utils";
import { useTranslation } from "react-i18next";
import ProfileNumberUpdate from "../components/ProfileNumberUpdate";
import ProfilePasswordUpdate from "../components/ProfilePasswordUpdate";
import { useSelector } from "react-redux";
import AppContainer from "components/ui/AppContainer";
import AppSimpleText from "components/ui/AppSimpleText";

const Profile = () => {
  const { t } = useTranslation();
  const [user, setUser] = useState();
  const { currentLanguage } = useSelector((state) => state.LanguageSlice);

  useEffect(() => {
    const userDetail = UTILS.getCurrentUser();
    setUser(userDetail);
  }, []);
  return (
    <AppContainer
      title={t("My profile")}
      subTitle={t(
        "Manage your personal information and security of your account",
        {
          company:
            currentLanguage === "EN"
              ? process.env.REACT_APP_COMPANY_NAME_EN
              : process.env.REACT_APP_COMPANY_NAME_AR,
        }
      )}
    >
      <div className="pb-8">
        <div className="my-4">
          <h1 className="text-19px font-medium">{t("Email")}</h1>
          <AppSimpleText>
            {t("Your current email address is")}{" "}
            <strong>{user?.email}</strong>
          </AppSimpleText>
        </div>

        <div className="w-full md:w-1/2 lg:w-3/4">
          <ProfilePasswordUpdate />
          <ProfileNumberUpdate />
        </div>
      </div>
    </AppContainer>
  );
};

export default Profile;
